module.exports = __webpack_public_path__ + "static/media/dodecahedron_faceting_2.f8788be7.png";